import React, { Dispatch, SetStateAction } from 'react';
import openEyeIcon from 'utils/icon/icon_eye-show-black.png';
import clostEyeIcon from 'utils/icon/icon_eye-hide-black.png';

interface IProps {
  isShow: boolean;
  setShowPass: Dispatch<SetStateAction<boolean>>;
}

const DisplayPassword: React.FC<IProps> = ({ isShow, setShowPass }) => {
  const handleClick = () => {
    setShowPass(!isShow);
  };

  return (
    <>
      {isShow ? (
        <img src={openEyeIcon} alt='show' onClick={handleClick} />
      ) : (
        <img src={clostEyeIcon} alt='hide' onClick={handleClick} />
      )}
    </>
  );
};

export default DisplayPassword;
